import { Navigate } from 'react-router';
import { Helmet } from 'react-helmet-async';

import { hasPermission } from 'src/utils/has-permissions';

import { useAuthContext } from 'src/auth/hooks';
import { AuthPermissions } from 'src/auth/permissions';

import AuditLogListView from 'src/sections/audit-log/view/audit-log-list-view';

export default function AuditLogListPage() {
  const { user: authUser } = useAuthContext();

  return (
    <>
      <Helmet>
        <title> Audit Log </title>
      </Helmet>

      {hasPermission(
        authUser,
        'any',
        AuthPermissions.READ_AUDIT,
        AuthPermissions.ADMIN_PERMISSION,
        AuthPermissions.SUPER_ADMIN_PERMISSION
      ) ? (
        <AuditLogListView />
      ) : (
        <Navigate to="/403" />
      )}
    </>
  );
}
